import { CONVERSATION_FACTS_MEASURES } from 'cube/constants'

import type { CubeQuery } from '@driftt/dds.reports'

/**
 * Base cube query for conversation count.
 */
export const ConversationCountQuery: CubeQuery = {
  name: 'ConversationCount',
  queryName: CONVERSATION_FACTS_MEASURES.CONVERSATION_COUNT,
  query: {
    measures: [CONVERSATION_FACTS_MEASURES.CONVERSATION_COUNT],
  },
}
